import Properties from "../_model/ModelEngineeringProperties";
import { NumberFormat } from "../../utils/tools";
import { UnitMensure } from "../../utils/unitsMeasure";
import ReceiptControl from "./simulationManagement/receiptControl"
import DispatchControl from "./simulationManagement/dispatchControl"
import EngineeringMapping from "./singletonTools/engineeringMapping";
import ValueOnStrucutre from "./singletonTools/valueOnStructureEnginnering";
import Navigate from "./singletonTools/navigatingTheEnginneringStructure";
// eslint-disable-next-line no-unused-vars
import DebugProperty from "@/components/flowchart/utils/debug"

export var SingletonEnginnering = {
    instance: function() {
        if (!SingletonEnginnering.instance) {
            SingletonEnginnering.instance = this;
        }
        return SingletonEnginnering.instance;
    },

    isLoaded: false,
    currents: null,
    operations: null,
    structureOfEnginnering: null,
    moendaOperations: null,
    structureOfEnginneringStatic: null,

    load: function(objStructure) {
        this.moendaOperations = Object.keys(objStructure["Operações"]).filter(
            (key) => objStructure["Operações"][key].moendaLigada
        );
        this.structureOfEnginnering = objStructure;
        this.structureOfEnginneringStatic = JSON.parse(JSON.stringify(objStructure));
        this.currents = Object.keys(objStructure["Correntes"]).sort();
        this.operations = Object.keys(objStructure["Operações"]).sort();
        console.log(this.currents.length + " Correntes carregadas");
        console.log(this.operations.length + " Operações carregadas");
        this.isLoaded = true;
    },

    updatePropertyValues: async function(properties) {
        await properties.forEach(async(prop) => {
            let value = await this.getValue(prop);
            prop.value = NumberFormat(value);
        });

        await ReceiptControl(properties)

        await properties.forEach(async(prop) => {
            ValueOnStrucutre.set(this.structureOfEnginnering, prop)
        });
    },

    setTableFlowChart: function(inputs) {
        DispatchControl(inputs)

        return inputs.map((n) => {
            return {
                item: EngineeringMapping.setMapping(n),
                value: n.value.toString(),
            };
        });
    },

    getCurrentProperties: function(index) {
        let objProps = this.structureOfEnginnering["Correntes"][index];
        let props = new Array();
        if(objProps){
            objProps.forEach((name, i) =>
                props.push({ name: Object.keys(name)[0], index: i })
            );
        }
        return props;
    },

    getCurrentPropertiesAttributes: function(index, prop) {
        let current = this.structureOfEnginnering["Correntes"][index]
        if (!current) {
            throw `ATENÇÃO - Corrente ${index} não encontrada na estrutura do engenharia.`
        }

        let objAttrs = current[prop.index][prop.name];
        let attr = new Array();
        Object.keys(objAttrs).forEach((a) =>
        {
            let newProp = new Properties({
                key: a,
                caption: a != 'W' && a != 'WVol' && a != 'T' && a != 'P' ? a : '',
                value: objAttrs[a],
                unit: UnitMensure[a],
                type: "Correntes",
                subType: "Atributos",
                index: index,
                propIndex: prop.index,
                propName: prop.name,
            })
            newProp.mapping = EngineeringMapping.setMapping(newProp)
            attr.push(newProp)
        });
        attr.sort();
        return attr;
    },

    getCurrentByMisturador: function(index, prop) {
        let stCurrent = this.structureOfEnginnering["Operações"][index].Saida[0]
        let attrs = this.getCurrentPropertiesAttributes(stCurrent, prop)
        return attrs
    },

    getOperationsProperties: function(index) {
        let operation = this.structureOfEnginnering["Operações"][index]
        if (!operation) {
            throw `ATENÇÃO - Operação ${index} não encontrada na estrutura do engenharia.`
        }
        
        let objOperations = operation.Atributos;
        let attr = new Array();
        Object.keys(objOperations).forEach((a) =>
        {
            let prop = new Properties({
                key: a,
                caption: a,
                value: objOperations[a],
                unit: UnitMensure[a],
                type: "Operações",
                subType: "Atributos",
                index: index,
            })
            prop.mapping = EngineeringMapping.setMapping(prop)
            attr.push(prop)
        });
        attr.sort((a, b) =>
            a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0
        );
        return attr;
    },

    getInnerCurrentOfTheOperation: function(index) {
        if (this.structureOfEnginnering["Operações"][index]["Correntes"])
            return Object.keys(this.structureOfEnginnering["Operações"][index]["Correntes"]);
        else return [];
    },

    getInnerCurrentOfComponents: function(index, component) {
        if (
            this.structureOfEnginnering["Operações"][index] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"][component] )
            return Object.keys(this.structureOfEnginnering["Operações"][index]["Correntes"][component]);
        else return [];
    },

    getAttributesPropertiesFromAnInnerCurrent: function(index, component){
        if (
            this.structureOfEnginnering["Operações"][index] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"][component] && 
            this.structureOfEnginnering["Operações"][index]["Correntes"][component].Atributos)
        {
            let objOperations = this.structureOfEnginnering["Operações"][index]["Correntes"][component].Atributos;
            let attr = new Array();
            Object.keys(objOperations).forEach((a) => 
            {
                let prop = new Properties({
                    key: a,
                    caption: a != 'W' ? a != 'fracapMassica' ? a : component : '',
                    value: objOperations[a],
                    unit: UnitMensure[a],
                    type: "CorrenteInterna",
                    component: component,
                    subType: "Atributos",
                    index: index,
                })
                prop.mapping = EngineeringMapping.setMapping(prop)
                attr.push(prop)
            });
            attr.sort((a, b) =>
                a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0
            );
            return attr;
        }
        else return [];
    },

    getComponentPropertiesFromAnInnerCurrentStrings: function(index, component, componenteType){
        if (
            this.structureOfEnginnering["Operações"][index] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"][component] && 
            this.structureOfEnginnering["Operações"][index]["Correntes"][component][componenteType])
        {
            return Object.keys(this.structureOfEnginnering["Operações"][index]["Correntes"][component][componenteType]);
        }
        else return [];
    },

    getComponentPropertiesFromAnInnerCurrent: function(index, component, componenteType){
        if (
            this.structureOfEnginnering["Operações"][index] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"] &&
            this.structureOfEnginnering["Operações"][index]["Correntes"][component] && 
            this.structureOfEnginnering["Operações"][index]["Correntes"][component]["Componentes"][componenteType])
        {
            let objOperations = this.structureOfEnginnering["Operações"][index]["Correntes"][component]["Componentes"][componenteType];
            let attr = new Array();
            Object.keys(objOperations).forEach((a) =>
            {
                let prop = new Properties({
                    key: a,
                    caption: a != 'W' ? a != 'fracaoMassica' ? a : componenteType : '',
                    value: objOperations[a],
                    unit: UnitMensure[a],
                    type: "CorrenteInterna",
                    component: component,
                    subType: componenteType,
                    index: index,
                })
                prop.mapping = EngineeringMapping.setMapping(prop)
                attr.push(prop)
            });

            attr.sort((a, b) =>
                a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0
            );
            return attr;
        }
        else return [];
    },

    getOperationsEquipments: function(index) {
        if (this.structureOfEnginnering["Operações"][index])
            return !this.structureOfEnginnering["Operações"][index].Equipamentos ? 
                    [] :
                    Object.keys(this.structureOfEnginnering["Operações"][index].Equipamentos);
        else return [];
    },

    getPropsByEquipment: function(index, nameEquipment) {  
        if (this.structureOfEnginnering["Operações"][index] &&
            this.structureOfEnginnering["Operações"][index].Equipamentos &&
            this.structureOfEnginnering["Operações"][index].Equipamentos[nameEquipment])
            {
                let propEquipment = [];
                
                let objEquipments = this.structureOfEnginnering["Operações"][index].Equipamentos[nameEquipment];
                let attrPartial = new Properties();

                attrPartial.index = index
                attrPartial.subType = "Equipamentos";
                attrPartial.type = "Operações";
                attrPartial.equipName = nameEquipment;

            Object.keys(objEquipments).forEach((e) => {
                let attrComplet = new Properties({...attrPartial });
                let isNum = !isNaN(objEquipments[e].replace(/\./g, '').replace(/,/g, '.'));

                attrComplet.key = e;
                attrComplet.caption = e;
                attrComplet.unit = UnitMensure[e];

                if (isNum) attrComplet.value = objEquipments[e];
                else attrComplet.strValue = objEquipments[e];
                attrComplet.mapping = EngineeringMapping.setMapping(attrComplet)

                propEquipment.push(attrComplet)
            });
            propEquipment.sort((a, b) => a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0 );
            return propEquipment
            }
        else {
            return this.getPropsByEquipmentOldMapping(index, nameEquipment);
        }
    },

    getPropsByEquipmentOldMapping(index, nameEquipment){
        if (this.structureOfEnginnering["Operações"])
        {
            let indexArray = Object.keys(this.structureOfEnginnering["Operações"])
            if(!indexArray.length) return []
            
            let indexfound = indexArray.find(map => map.includes(index.split("|")[0]) && map.split("|")[1].length == index.split("|")[0].length)
            if(!indexfound) return []

            return this.getPropsByEquipment(indexfound, nameEquipment)
        }
        return []
    },

    getEquipamentsProperties: function(index) {
        let equipmentList = this.getOperationsEquipments(index);
        let propEquipments = [];

        if (!this.structureOfEnginnering["Operações"][index]) return propEquipments;

        equipmentList.forEach((equip) => {
            let propEquipment = this.getPropsByEquipment(index, equip)
            propEquipments[propEquipment[0].equipName] = propEquipment;
        });
        return propEquipments;
    },
    
    getAllEquipmentProperties: function (index) {
        let equipmentList = this.getEquipamentsProperties(index);
        let propsEquip = [];
        
        for (const e in equipmentList) {
            let propEquipment = this.getPropsByEquipment(index, e)
            propsEquip = [...propEquipment, ...propsEquip];
        }
        return propsEquip.sort((a, b) => a.equipName > b.equipName ? 1 : a.equipName == b.equipName ? 0 : -1);
    },

    getPropertieByToken(mapping = "cr|1_1|Atributos|W") {
        try {
            if(!this.isLoaded)
                throw `Estrutura de objeto não carregada.`

            if (mapping.match(/\b(cr)/) || mapping.match(/\b(cp)/)) 
                return this.getPropCurrentOrComponentByToken(mapping)

            else if (mapping.match(/\bop/)) 
                return this.getPropOperationByToken(mapping)
                
            else if (mapping.match(/\beq/)) 
                return this.getPropEquipmentByToken(mapping)
            
            else if (mapping.match(/\bin/)) 
                return this.getPropInnerCurrentByToken(mapping)

            else if (mapping.match(/\bci/)) 
                return this.getPropInnerComponentByToken(mapping)

            return "-9999";
        } catch (e) {
            return;
        }
    },

    getPropCurrentOrComponentByToken(mapping = "cp|1_1|Caldo|brix"){
        let {
            stCurrent,
            stProp,
            stAttr
        } = {...EngineeringMapping.unstructureMapping(mapping) }

        let props = this.getCurrentProperties(stCurrent)
        let prop = props.find(p => p.name == stProp)
        let propAttrs = this.getCurrentPropertiesAttributes(stCurrent, prop)
        let attr = propAttrs.find(a => a.key == stAttr)

        return attr
    },

    getPropOperationByToken(mapping = "op|DemandaEnergia|DE_1001|consumoEspecifico"){
        let {
            operation,
            stAttr
        } = {...EngineeringMapping.unstructureMapping(mapping) }

        let props = this.getOperationsProperties(operation)
        let prop = props.find(p => p.key == stAttr)

        return prop
    },

    getPropEquipmentByToken(mapping = "eq|Decantador|DE_1|Decantador_3|Capacidade"){
        let {
            operation,
            equipment,
            stAttr,
        } = {...EngineeringMapping.unstructureMapping(mapping) }
        
        let props = this.getPropsByEquipment(operation, equipment)
        let prop = props.find(p => p.key == stAttr)

        return prop
    },

    getPropInnerCurrentByToken(mapping = "in|Fermentacao|RBB_701|VinhoBruto|ART"){
        let {
            operation,
            componentType,
            stAttr
        } = {...EngineeringMapping.unstructureMapping(mapping) }

        let props = this.getAttributesPropertiesFromAnInnerCurrent(operation, componentType)
        let prop = props.find(p => p.key == stAttr)

        return prop
    },
    
    getPropInnerComponentByToken(mapping = "ci|Fermentacao|RBB_701|MostoLevedurado|Caldo|fracaoMassica"){
        let {
            operation,
            component,
            componentType,
            stAttr
        } = {...EngineeringMapping.unstructureMapping(mapping) }

        let props = this.getComponentPropertiesFromAnInnerCurrent(operation, component, componentType)
        let prop = props.find(p => p.key == stAttr)

        return prop
    },

    getValueByToken(mapping = "cr|1_1|Atributos|W"){
        try{
            let prop = this.getPropertieByToken(mapping)
            if(prop)
                return this.getValue(prop)
            return "-9999"
        }
        catch (e){
            console.warn(`Não foi possível encontrar o mapeamento ${mapping} \nErro: ${e}`)
            return "-9999"
        }
    },

    setValueByToken(mapping = new String, value = new String){
        try{
            let prop = this.getPropertieByToken(mapping)
            prop.value = value
            if(prop)
                return this.setValue(prop)
            return "-9999"
        }
        catch (e){
            console.warn(`Não foi possível encontrar o mapeamento ${mapping} \nErro: ${e}`)
            return "-9999"
        }
    },

    hasMapping: function(mapping = new String) {
        try {
            this.getValueByToken(mapping)
            return true
        } catch (e) {
            return false
        }
    },

    getValue: function (prop){ return ValueOnStrucutre.get(this.structureOfEnginnering, prop) },

    setValue: function (prop){ return ValueOnStrucutre.set(this.structureOfEnginnering, prop) },

    getReferenceProperties: function (index){
        let propAttrs = []
        let propCaldo = [
            new Properties({key: "pureza", unit:"%", index: index}), 
            new Properties({key: "brix", unit:"%", index: index})
        ]

        if(!this.structureOfEnginnering["Correntes"][index])
            return []

        let properties = this.structureOfEnginnering["Correntes"][index]
        for(let i in properties){
            let prop = properties[i]
            if(prop.Atributos)
                propAttrs = this.getCurrentPropertiesAttributes(index, {index: i, name: "Atributos"})

            if(prop.Caldo)
                propCaldo = this.getCurrentPropertiesAttributes(index, {index: i, name: "Caldo"}).filter(p => p.key == "pureza" || p.key == "brix")
        }
        return [...propAttrs, ...propCaldo];
    },

    getCurrentByInputOfOperation (op = new String, input = new Number){
        return  this.structureOfEnginnering["Operações"][op].Entrada[input - 1]
    },

    getCurrentByOutputOfOperation (op = new String, output = new Number){
        return  this.structureOfEnginnering["Operações"][op].Saida[output - 1]
    },

    getAttributesOfOperationByCurrent(current = new String){
        let operations = Navigate.FindOperationsByCurrent(this.structureOfEnginnering, current)
        let attrsOperations = operations.map(index => {
            let attrs = this.getOperationsProperties(index)
            return { index, attrs  }
        })
        return attrsOperations
    },

    getAllPropertiesInCurrent(index) {
        let allProperties = []
        let props = this.getCurrentProperties(index);
        props.forEach(prop => {
            allProperties = [...this.getCurrentPropertiesAttributes(index, prop), ...allProperties]
        });
        return allProperties
    },

    Kill: function() {
        this.isLoaded = false;
        this.currents = null;
        this.operations = null;
        this.structureOfEnginnering = null;
        this.moendaOperations = null;
        this.instance = null
    }
};